import React from "react";
// import Dialog from '@material-ui/core/Dialog';
// import DialogActions from '@material-ui/core/DialogActions';
// import DialogContent from '@material-ui/core/DialogContent';
import Snackbar from "@material-ui/core/Snackbar";
import { IconButton, makeStyles } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";

const snackbarStyles = makeStyles({
  root: {
    '& .MuiSnackbarContent-root': {
      borderRadius: '8px',
      background: 'white'
    },
    '& .MuiIconButton-colorInherit': {
      color: '#212B36'
    }
  },
})

const DialogModule = ({
  open,
  setOpen,
  content,
  action,
  style = {} || null,
  ...otherProps
}) => {
  return (
    <Snackbar
    classes={snackbarStyles()}
      open={open}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "left",
      }}
      autoHideDuration={3000}
      onClose={() => {
        setOpen && setOpen(false);
      }}
      message={content}
      action={
        <>
          <IconButton
            size="small"
            aria-label="close"
            color="inherit"
            onClick={() => setOpen(false)}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        </>
      }
      {...otherProps}
    > 
    </Snackbar>
  );
};

export default DialogModule;
